import { IPricingTooltip } from '../interfaces/IPricingTooltip';

const PRICING_BASIC_TOOLTIPS: IPricingTooltip[] = [
  {
    id: 1,
    title: 'Measurement PDF',
    tooltip:
      'Per property measurements are accurate to within 5% (in aggregate)',
  },
  {
    id: 2,
    title: 'Interactive 3D Model',
    tooltip:
      'Help homeowners understand their estimates and see their new roof, siding, and windows with real products on their homes.',
  },
  {
    id: 3,
    title: '12-month Property Storage',
    tooltip:
      'Keep all your projects, measurements and 3D models in our cloud for 12 months',
  },
  {
    id: 4,
    title: 'Basic data export',
    tooltip: 'Export all measurement data to XLS and PDF',
  },
  {
    id: 5,
    title: 'Direct ordering',
    tooltip:
      'Order electronically form leading suppliers with zero manual entry and without leaving the console',
  },
];

export default PRICING_BASIC_TOOLTIPS;
